<div class="sr-dialog">
  <!-- Header -->
  <div class="sr-dialog-header">
    <h2 class="sr-dialog-title">
      {{ data.response.title }}
    </h2>

    <button mat-icon-button (click)="close()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Description -->
  <div class="sr-dialog-description" *ngIf="data.response.description">
    {{ data.response.description }}
  </div>

  <!-- Download prescription -->
  <div class="prescription-banner" *ngIf="data.response.prescriptionRequired">
    <div class="prescription-banner-icon">
      <mat-icon aria-hidden="true">description</mat-icon>
    </div>
    <div class="prescription-banner-content">
      <p class="prescription-banner-title">{{ "page.home.predispositions.prescriptionNecessary" | translate }}</p>
      <p class="prescription-banner-sub">{{ "page.home.predispositions.prescriptionDescription" | translate }}</p>
    </div>
    <!-- TODO GLOR-238: url from backend -->
    <a
      href="https://slbo.be/wp-content/uploads/2017/03/2677-v9-i0-b1-fo-pre-30007-bon-de-demande-5.pdf"
      target="_blank"
      class="prescription-download-btn"
      [matTooltip]="'page.home.predispositions.downloadPrescription' | translate"
      aria-label="Download prescription"
    >
      <i class="ti ti-download" aria-hidden="true"></i>
      {{ "common.download" | translate }}
    </a>
  </div>

  <!-- Different results Carousel -->
  <div class="carousel-section" *ngIf="results && results.length > 0">
    <app-carousel [items]="results" [itemsPerView]="1" (itemViewed)="onResultViewed($event)">
      <ng-template let-result>
        <div class="result-card">
          <div class="result-card-header">
            <span class="result-status" *ngIf="result.status === 'NOT_READ'">
              {{ "common.new" | translate }}
            </span>
          </div>

          <div class="result-card-body">
            <!-- Quantity -->
            <div *ngIf="result.valueQuantity" class="result-value">
              <span class="value-label">{{ "page.home.predispositions.result.quantity" | translate }}</span>
              <div class="quantity-display">
                <span class="quantity-number">{{ result.valueQuantity.value }}</span>
                <span class="quantity-unit">{{ result.valueQuantity.unit }}</span>
              </div>
            </div>

            <!-- String -->
            <div *ngIf="result.valueString !== undefined && result.valueString !== null" class="result-value">
              <span class="value-label">{{ "page.home.predispositions.result.note" | translate }}</span>
              <div class="string-display">
                <span>{{ result.valueString }}</span>
              </div>
            </div>

            <!-- Boolean -->
            <div *ngIf="result.valueBoolean !== undefined && result.valueBoolean !== null" class="result-value">
              <span class="value-label">{{ "page.home.predispositions.result.result" | translate }}</span>
              <div class="bool-display">
                <span class="bool-badge" [class.true]="result.valueBoolean" [class.false]="!result.valueBoolean">
                  <i class="ti" [class.ti-check]="result.valueBoolean" [class.ti-x]="!result.valueBoolean"></i>
                  {{ result.valueBoolean ? ("common.yes" | translate) : ("common.no" | translate) }}
                </span>
              </div>
            </div>

            <!-- Integer -->
            <div *ngIf="result.valueInteger !== undefined && result.valueInteger !== null" class="result-value">
              <span class="value-label">{{ "page.home.predispositions.result.score" | translate }}</span>
              <div class="integer-display">
                <span class="integer-number">{{ result.valueInteger }}</span>
                <div class="integer-ticks" aria-hidden="true">
                  <div
                    *ngFor="let tick of result.ticks"
                    class="integer-tick"
                    [class.active]="tick.active"
                    [style.height.%]="tick.height"
                  ></div>
                </div>
              </div>
            </div>

            <!-- Range -->
            <div *ngIf="result.valueRange" class="result-value">
              <span class="value-label">{{ "page.home.predispositions.result.range" | translate }}</span>
              <div class="range-display">
                <div class="range-labels">
                  <div class="range-label-item low">
                    <span class="range-label-val">{{ result.valueRange.low.value }}</span>
                    <span class="range-label-unit">{{ result.valueRange.low.unit }} </span>
                  </div>
                  <div class="range-label-item high">
                    <span class="range-label-val">{{ result.valueRange.high.value }}</span>
                    <span class="range-label-unit">{{ result.valueRange.high.unit }} </span>
                  </div>
                </div>
                <div class="range-track-wrap">
                  <div class="range-fill"></div>
                  <div class="range-dot" style="left: 0%"></div>
                  <div class="range-dot" style="left: 100%"></div>
                </div>
              </div>
            </div>

            <!-- Ratio -->
            <div *ngIf="result.valueRatio" class="result-value">
              <span class="value-label">{{ "page.home.predispositions.result.ratio" | translate }}</span>
              <div class="ratio-display">
                <div class="ratio-numbers">
                  <ng-container *ngIf="result.valueRatio.denominator.value === 100; else ratio">
                    <div class="ratio-part">
                      <span class="ratio-val">{{ result.ratioPercent | number: "1.0-2" }}</span>
                      <span class="ratio-unit-label">%</span>
                    </div>
                  </ng-container>

                  <ng-template #ratio>
                    <div class="ratio-part">
                      <span class="ratio-val">{{ result.valueRatio.numerator.value }}</span>
                      <span class="ratio-unit-label">{{ result.valueRatio.numerator.unit }}</span>
                    </div>
                    <span class="ratio-divider">/</span>
                    <div class="ratio-part">
                      <span class="ratio-val">{{ result.valueRatio.denominator.value }}</span>
                      <span class="ratio-unit-label">{{ result.valueRatio.denominator.unit }}</span>
                    </div>
                  </ng-template>
                </div>
                <div class="ratio-bar-outer">
                  <div class="ratio-bar-fill" [style.width.%]="result.ratioPercent"></div>
                </div>
                <div class="ratio-pct">
                  {{ result.ratioPercent | number: "1.0-2" }}% — {{ result.valueRatio.numerator.value }} of
                  {{ result.valueRatio.denominator.value }}
                </div>
              </div>
            </div>
          </div>

          <div class="result-attachment" *ngIf="result.valueAttachment?.url as url">
            <span class="result-date">
              {{ "page.home.predispositions.result.date" | translate }}:
              {{ result.valueAttachment.creation | localizedDate: "dd MMMM yyyy" }}
            </span>
            <a
              [href]="url"
              target="_blank"
              class="download-btn"
              mat-icon-button
              [matTooltip]="'page.home.predispositions.result.downloadResult' | translate"
              aria-label="Download result"
            >
              <mat-icon>file_download</mat-icon>
            </a>
          </div>
        </div>
      </ng-template>
    </app-carousel>
  </div>

  <!-- Price & Add to cart -->
  <div class="sr-dialog-price">
    <div class="price-info">
      <span class="price-label">{{ "page.order.price" | translate }}</span>
      <span class="item-price">
        <div class="price">
          {{ data.response.price.value | minorUnitCurrency: data.response.price.currency }}
        </div>

        <span *ngIf="data.response.price.timing" class="subscription-badge">
          {{
            "page.order.timing." + data.response.price.timing.periodUnit | pluralTranslate: data.response.price.timing.period | lowercase
          }}
        </span>
      </span>
    </div>

    <div class="price-button">
      <button *ngIf="data.canPurchase" class="primary-button" (click)="onCartClick($event)" [disabled]="loadingAddToCart">
        {{ data.response.identifier.value | cartTooltip: isInCart.bind(this) : undefined : data.alreadyBought | translate }}
      </button>

      <ng-container *ngIf="!data.canPurchase">
        <button *ngIf="data.paymentStatus === 'PAID'" class="primary-button" (click)="unsubscribe($event)" [disabled]="loadingUnsubscribe">
          {{ "page.risk.tooltip.unsubscribe" | translate }}
        </button>

        <div class="paidUntil-info" *ngIf="data.paymentStatus !== 'PAID' && data.paidUntil">
          <span class="paidUntil-label">{{ "page.home.serviceRequest.paidUntil" | translate }}</span>
          <span class="item-paidUntil">
            <div class="paidUntil">
              {{ data.paidUntil | localizedDate: "dd MMMM yyyy" }}
            </div>
          </span>
        </div>
      </ng-container>
    </div>
  </div>
</div>
